// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".c-textfield--phone[data-v-5cb1c563]{width:151px;max-width:151px}", ""]);
// Exports
module.exports = exports;
